const base = "https://unio-backend.herokuapp.com/api/v1";
// const base = "http://localhost:3000/api/v1";
// export const base =
//   process.env.NODE_ENV === "development"
//     ? "http://localhost:3000/api/v1"
//     : "https://unio-backend.herokuapp.com/api/v1";
// redeploy

const urls = {
  //DOCTORS
  addUserDoctor: `${base}/user/doctor`,
  loginDoctor: `${base}/user/login`,
  editDoctorProfile: `${base}/user`,
  updatePassword: `${base}/user/reset-password`,
  sendTokenResetPassword: `${base}/user/token-password?pwa=1`,
  getSpecialties: `${base}/specialties`,
  getDoctorKit: `${base}/doctor-kit`,
  getOrdersList: `${base}/orders/doctor`,
  getPatiensAssignProducts: `${base}/patients-assign-products`,
  addDoctorReport: `${base}/doctor-report`,
  notifications: `${base}/doctor-notifications`,
  verifyTokenValidity: `${base}/users/verifyTokenValidity`,
  verifyEmail: `${base}/user/verify-email`,
  resendVerificationEmail: `${base}/user/resend-verification`,
  //PATIENTS
  assignProduct: `${base}/patients-assign-products`,
  //LABS
  getLabs: `${base}/laboratories`,
  getProductsFromLab: `${base}/products`,
  addOrder: `${base}/order`,
  // CONSENTS
  getDoctorSignedConsents: `${base}/informedConsents/getDoctorSignedConsentsCheck`,
  getLastConsentVersion: `${base}/informedConsents/getLastVersion`,
  refreshToken: `${base}/user/refresh-token`,
  logout: `${base}/user/logout`,
};

export default urls;
